import { ChapterCreate } from './ChapterCreate';
import { ChapterEdit } from './ChapterEdit';
import { ChapterList } from './ChapterList';

export default {
    create: ChapterCreate,
    edit: ChapterEdit,
    list: ChapterList
}
